import Link from "next/link";
import { Intermedes } from "../icons-legacy/Intermedes";

type Props = {
  frontUrl: string;
};
export const Legals = ({ frontUrl }: Props) => {
  return (
    <div className="bg-primary text-white text-sm xl:text-base">
      <div className="container mx-auto px-5 md:px-10 flex h-16 items-center flex-wrap content-center">
        <p className="px-0.5">{`© Copyright Intermèdes ${new Date().getFullYear()}`}</p>
        <p className="px-0.5 hidden md:block">{" | "}</p>
        <div className="h-0 basis-full md:hidden" />
        <Link prefetch={false} href={`${frontUrl}/entreprise/donnees-et-garanties/`} className="px-0.5 cursor-pointer">
          Mentions légales
        </Link>
        <p className="px-0.5">{" | "}</p>
        <Link
          prefetch={false}
          href={`${frontUrl}/entreprise/credits-photos-voyages/`}
          className="px-0.5 cursor-pointer"
        >
          Crédits
        </Link>
        <p className="px-0.5">{" | "}</p>
        <Link prefetch={false} href={`${frontUrl}/plan-du-site/`} passHref className="text-white px-0.5 no-underline">
          Plan du site
        </Link>
        <div className="grow" />
        <div className="brightness-0 invert w-36 hidden xl:block">
          <Intermedes className="w-full" />
        </div>
      </div>
    </div>
  );
};
